// extracted by mini-css-extract-plugin
module.exports = {"lottiePlay":"error404Page_lottiePlay__2o_kA"};